import React from "react"
import { Terminal, Truck, ShoppingBag } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useScrollAnimation } from "../hooks/useScrollAnimation"

export default function Features() {
    const { t } = useTranslation()
    const ref = useScrollAnimation()

    const features = [
        {
            icon: <Terminal className="w-10 h-10 text-emerald-600" />,
            title: t('features.card1_title'),
            description: t('features.card1_desc'),
        },
        {
            icon: <Truck className="w-10 h-10 text-emerald-600" />,
            title: t('features.card2_title'),
            description: t('features.card2_desc'),
        },
        {
            icon: <ShoppingBag className="w-10 h-10 text-emerald-600" />,
            title: t('features.card3_title'),
            description: t('features.card3_desc'),
        },
    ]

    return (
        <section id="what-we-do" ref={ref} className="scroll-animate py-24 bg-white relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-emerald-500/10 to-transparent"></div>

            <div className="container mx-auto px-4 md:px-6 relative z-10">
                <div className="text-center max-w-3xl mx-auto mb-20">
                    <h2 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl mb-6">
                        {t('features.title')}
                    </h2>
                    <p className="text-xl font-medium text-emerald-600 mb-6 uppercase tracking-widest">
                        {t('features.subtitle')}
                    </p>
                    <p className="text-xl text-slate-500 leading-relaxed">
                        {t('features.description')}
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    {features.map((feature, index) => (
                        <div key={index} className="card-slide-left group relative bg-white p-10 rounded-[2.5rem] shadow-sm border border-slate-100 hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 transform-gpu">
                            <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 to-transparent opacity-0 group-hover:opacity-100 rounded-[2.5rem] transition-opacity duration-500"></div>

                            <div className="relative z-10">
                                <div className="mb-8 p-5 bg-emerald-50 rounded-2xl w-fit group-hover:bg-emerald-500 group-hover:shadow-[0_0_20px_rgba(16,185,129,0.3)] transition-all duration-500">
                                    {React.cloneElement(feature.icon as React.ReactElement<{ className?: string }>, {
                                        className: "w-10 h-10 text-emerald-600 group-hover:text-white transition-colors duration-500"
                                    })}
                                </div>
                                <h3 className="text-2xl font-bold text-slate-900 mb-4 group-hover:text-emerald-700 transition-colors duration-300">
                                    {feature.title}
                                </h3>
                                <p className="text-slate-600 leading-relaxed text-lg">
                                    {feature.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
